export default "__VITE_ASSET__475a57b6__"